import * as THREE from 'three';
import { handleHeight } from './slidingHandleSpec';

function meshMaterial() {
  const canvas = document.createElement('canvas'); canvas.width = canvas.height = 32;
  const ctx = canvas.getContext('2d'); ctx.clearRect(0, 0, 32, 32);
  ctx.fillStyle = '#424940'; ctx.fillRect(0, 0, 4, 32); ctx.fillRect(0, 0, 32, 4);
  ctx.fillStyle = '#70796a'; ctx.fillRect(0, 0, 2, 32); ctx.fillRect(0, 0, 32, 1);
  const map = new THREE.CanvasTexture(canvas); map.wrapS = map.wrapT = THREE.RepeatWrapping;
  map.colorSpace = THREE.SRGBColorSpace;
  const material = new THREE.MeshStandardMaterial({ map, color: '#727c6c', side: THREE.DoubleSide, transparent: true, opacity: .7, roughness: 1, metalness: 0, depthWrite: false });
  material.userData.role = 'insect-mesh';
  return material;
}

export function buildInsectScreen(parent, width, height, depth, frame, metal, options = {}) {
  const root = new THREE.Group(); root.name = 'independent-pleated-screen'; parent.add(root);
  const railZ = options.railZ ?? depth / 2 + .052, left = -width / 2 + .04, right = options.right ?? width / 2 - .025;
  const bar = (w, h, d, x, y, z, material = frame) => {
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), material);
    mesh.position.set(x, y, z); mesh.castShadow = true; mesh.receiveShadow = true; root.add(mesh); return mesh;
  };
  bar(.035, height, .056, -width / 2 + .0175, height / 2, railZ);
  if (!options.openCorner) bar(.025, height, .056, width / 2 - .0125, height / 2, railZ);
  root.userData.fixedEndReceiver = !options.openCorner;
  for (const y of [.02, height - .02]) {
    bar(width, .04, .003, 0, y, railZ - .03);
    bar(width, .04, .003, 0, y, railZ + .03);
    bar(width, .003, .06, 0, y === .02 ? .0015 : height - .0015, railZ);
  }
  const count = 80, clothLength = right - left, clothFacet = clothLength * 1.018 / count;
  const vertices = new Float32Array((count + 1) * 6), uv = new Float32Array((count + 1) * 4), indices = [];
  for (let i = 0; i <= count; i++) {
    uv.set([i * clothFacet / .002, 0, i * clothFacet / .002, (height - .08) / .002], i * 4);
    if (i < count) { const a = i * 2; indices.push(a, a + 2, a + 1, a + 2, a + 3, a + 1); }
  }
  const geometry = new THREE.BufferGeometry(); geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
  geometry.setAttribute('uv', new THREE.BufferAttribute(uv, 2)); geometry.setIndex(indices);
  const cloth = new THREE.Mesh(geometry, meshMaterial()); cloth.name = 'pleated-screen-mesh'; cloth.castShadow = false; root.add(cloth);
  const pull = bar(.018, height - .08, .026, left + .055, height / 2, railZ, frame);
  const handle = bar(.012, .16, .016, left + .055, handleHeight(height), railZ + .025, metal);
  handle.name = 'insect-screen-handle';
  const animate = progress => {
    const span = .055 + progress * (clothLength - .055);
    const amplitude = Math.sqrt(Math.max(0, clothFacet ** 2 - (span / count) ** 2));
    for (let i = 0; i <= count; i++) {
      const x = left + i * span / count, z = railZ + (i % 2 ? amplitude / 2 : -amplitude / 2);
      vertices.set([x, .04, z, x, height - .04, z], i * 6);
    }
    geometry.attributes.position.needsUpdate = true; geometry.computeVertexNormals(); geometry.computeBoundingSphere(); geometry.computeBoundingBox();
    pull.position.x = handle.position.x = left + span;
    root.userData.extension = progress;
  };
  animate(0); return { root, animate };
}